import { AnimatePresence, motion } from 'framer-motion';
import { TabbedStaticCarouselProps } from '.';

const DesktopActiveSlide = ({ activeFeature }: { activeFeature: TabbedStaticCarouselProps['slides'][number] }) => {
  return (
    <div className="md:block w-full aspect-[1253/652] relative flex justify-center max-w-[1254px]">
      <div className="flex w-full max-w-[1253px]">
        <div className="rounded-10 overflow-hidden">
          {/* Active feature image/animation. */}
          <AnimatePresence mode="wait">
            {activeFeature && (
              <motion.div
                // Key is needed to ensure the animation is triggered when the feature changes.  
                key={activeFeature.title}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                exit={{ opacity: 0 }}
              >
                {activeFeature.image}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default DesktopActiveSlide;
